import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

const variantMap = {
  h1: { tag: 'h1', classes: 'text-4xl font-bold' },
  h2: { tag: 'h2', classes: 'text-3xl font-bold' },
  h3: { tag: 'h3', classes: 'text-2xl font-semibold' },
  h4: { tag: 'h4', classes: 'text-xl font-semibold' },
  h5: { tag: 'h5', classes: 'text-lg font-medium' },
  h6: { tag: 'h6', classes: 'text-base font-medium' },
  subtitle1: { tag: 'p', classes: 'text-base font-medium' },
  subtitle2: { tag: 'p', classes: 'text-sm font-medium' },
  body1: { tag: 'p', classes: 'text-sm' },
  body2: { tag: 'p', classes: 'text-xs' },
  caption: { tag: 'span', classes: 'text-xs text-text-secondary' },
  overline: { tag: 'span', classes: 'text-xs uppercase tracking-wider' },
  inherit: { tag: 'span', classes: '' }
}

export const AdasTypography = ({
  children,
  variant = 'body1',
  component,
  className,
  color,
  style,
  align,
  textAlign,
  paddingBottom,
  paddingTop,
  gutterBottom,
  fontWeight,
  // eslint-disable-next-line no-unused-vars
  mb,
  // eslint-disable-next-line no-unused-vars
  noWrap,
  ...props
}) => {
  const { tag: DefaultTag, classes } = variantMap[variant] || variantMap.body1
  const Tag = component || DefaultTag
  const effectiveAlign = align || textAlign
  const alignClass =
    effectiveAlign === 'center' ? 'text-center' : effectiveAlign === 'right' ? 'text-right' : effectiveAlign === 'left' ? 'text-left' : ''
  const combinedStyle = {
    ...(color !== undefined && { color }),
    ...(paddingBottom !== undefined && { paddingBottom }),
    ...(paddingTop !== undefined && { paddingTop }),
    ...(fontWeight !== undefined && { fontWeight }),
    ...style
  }
  return (
    <Tag className={cn(classes, alignClass, gutterBottom && 'mb-2', className)} style={combinedStyle} {...props}>
      {children}
    </Tag>
  )
}

AdasTypography.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
  component: PropTypes.elementType,
  className: PropTypes.string,
  color: PropTypes.string,
  style: PropTypes.object,
  align: PropTypes.string,
  paddingBottom: PropTypes.string,
  paddingTop: PropTypes.string
}
